<template>
  <div class="auth-layout page-wrap">
    <section class="auth-layout__hero surface">
      <!--<BrandMark />
      <div class="auth-layout__eyebrow">{{ brandName }}</div>-->
      
      <BrandMarkBackground/>

      <h1>Играй в темпе своей галактики.</h1>
      <p>
        Бронирование мест, баланс, бонусы, любимые клубы и управление бронями — в одном аккуратном интерфейсе.
      </p>
      <div class="auth-layout__features">
        <div>• Топовые ПК и комфортные игровые места</div>
        <div>• Мгновенная бронь компьютера в пару кликов</div>
        <div>• Турниры, акции и бонусы для постоянных гостей</div>
      </div>
    </section>
    <section class="auth-layout__card surface">
      <slot />
    </section>
  </div>
</template>

<script>
import BrandMark from '../brand/BrandMark.vue';
import BrandMarkBackground from '../brand/BrandBackground.vue'

export default {
  name: 'AuthLayout',
  components: { BrandMark, BrandMarkBackground },
};
</script>

<style scoped src="./AuthLayout.css"></style>
